module.exports = __webpack_public_path__ + "img/sad_amara.4fbfc348.png";